module.exports = __webpack_public_path__ + "img/household.31a4d10d.png";